import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import merge from 'lodash.merge';
import Wrapper from 'src/Wrapper';

import { Palette } from 'src/components';
import { Style1 } from 'src/styles';
import { stylePropType } from 'src/PropTypes';
import themes from 'src/themes';

function PxHistogram({
	title,
	style,
	series,
	options,
	theme: themeProp,
	onThemeChange,
	showPalette: showPaletteProp,
	defaultTheme,
}) {
	const [theme, setTheme] = useState(themeProp);
	const [showPalette, setShowPalette] = useState(series.length < 2 ? showPaletteProp : false);

	useEffect(() => {
		setTheme(themeProp);
	}, [themeProp]);

	useEffect(() => {
		setShowPalette(series.length < 2 ? showPaletteProp : false);
	}, [series, showPaletteProp]);

	const seriesList = [];
	const length = series.length > 0 ? series[0].values.length : 100;
	for (let i = 0; i < series.length; i += 1) {
		seriesList.push({
			name: series[i].name,
			data: series[i].values,
			type: 'bar',
			animationDelayUpdate: (idx) => idx * 5,
			...style.PxHistogram.series,
			itemStyle: {
				...style.PxHistogram.series.itemStyle,
				color: series[i].theme && themes[series[i].theme] ? themes[series[i].theme].color[0] : undefined,
			},
		});
	}
	const chartOption = {
		title: {
			text: title,
			...style.global.title,
		},
		grid: {
			...style.PxHistogram.grid,
		},
		textStyle: {
			...style.PxHistogram.textStyle,
		},
		label: {
			...style.PxHistogram.label,
		},
		tooltip: {
			...style.PxHistogram.tooltip,
		},
		legend: {
			...style.PxHistogram.legend,
		},
		xAxis: {
			...style.PxHistogram.xAxis,
			data: [...Array(length).keys()],
		},
		yAxis: {
			...style.PxHistogram.yAxis,
		},
		series: seriesList,
	};
	const mergedOptions = merge({}, chartOption, options);
	return (
		<Wrapper>
			<ReactEcharts
				style={{
					width: '100%',
					height: showPalette ? 'calc(100% - 2.5rem)' : '100%',
				}}
				option={mergedOptions}
				theme={theme}
				notMerge
			/>
			{showPalette ? (
				<Palette
					defaultTheme={defaultTheme}
					selected={theme}
					onSelect={(newTheme) => {
						setTheme(newTheme);
						onThemeChange(newTheme);
					}}
					style={{
						backgroundColor: mergedOptions.backgroundColor,
						width: '10rem',
						margin: '0 auto',
						paddingTop: '0.5rem',
					}}
				/>
			) : null}
		</Wrapper>
	);
}

PxHistogram.propTypes = {
	title: PropTypes.string,
	style: stylePropType,
	series: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			values: PropTypes.arrayOf(PropTypes.number),
		})
	).isRequired,
	options: PropTypes.shape({}),
	theme: PropTypes.string,
	onThemeChange: PropTypes.func,
	showPalette: PropTypes.bool,
};

PxHistogram.defaultProps = {
	title: '',
	style: Style1,
	options: {},
	theme: 'pinpoint',
	onThemeChange: () => null,
	showPalette: true,
};

export default PxHistogram;
